import React from "react";

interface props {
  style?: React.CSSProperties;
  symbol: string| undefined;
}
const symbolMapping: Record<string, string> = {
  "£": "£",
  "￡": "£",
  "¥": "¥",
  "€": "€",
};

const getCurrencySymbolByCharactor = (symbol: string|undefined) => {
  return symbolMapping[symbol?.trim() ?? ''] || symbol;
};

const JDICurrencySymbol = ({ style, symbol }: props) => {
  return <span style={style}>{getCurrencySymbolByCharactor(symbol)}</span>;
};

export default JDICurrencySymbol;
